import React from 'react';
import { SendHorizonal, Search } from 'lucide-react';
import { motion } from 'framer-motion';
import styles from './ConversationalOnboarding.module.scss';

interface ChatInputProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  onKeyPress: (e: React.KeyboardEvent) => void;
  disabled?: boolean;
  placeholder?: string;
  isOptional?: boolean;
  fieldType?: string;
  onSkip?: () => void;
  skipLabel?: string;
}

const ChatInput: React.FC<ChatInputProps> = ({
  value,
  onChange,
  onSend,
  onKeyPress,
  disabled = false,
  placeholder = 'Escribí tu respuesta...',
  isOptional = false,
  fieldType,
  onSkip,
  skipLabel = 'Omitir',
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let newValue = e.target.value;
    
    if (fieldType === 'tel') {
      newValue = newValue.replace(/[^0-9]/g, '');
    }
    
    onChange(newValue);
  };

  return (
    <div className={styles.chatInputContainer}>
      <Search size={20} className={styles.searchIcon} />
      <textarea
        className={styles.chatInput}
        value={value}
        onChange={handleChange}
        onKeyDown={onKeyPress}
        placeholder={placeholder}
        disabled={disabled}
        rows={1}
      />
      {isOptional && onSkip && (
        <motion.button
          className={styles.skipButton}
          onClick={onSkip}
          disabled={disabled}
          type="button"
          aria-label="Omitir campo"
          whileHover={!disabled ? { scale: 1.05 } : {}}
          whileTap={!disabled ? { scale: 0.95 } : {}}
        >
          {skipLabel}
        </motion.button>
      )}
      <motion.button
        className={styles.sendButton}
        onClick={onSend}
        disabled={disabled || !value.trim()}
        type="button"
        aria-label="Enviar mensaje"
        whileHover={!disabled && value.trim() ? { scale: 1.05 } : {}}
        whileTap={!disabled && value.trim() ? { scale: 0.95 } : {}}
      >
        <SendHorizonal size={20} />
      </motion.button>
    </div>
  );
};

export default ChatInput;
